import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d7472b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Welcome to mimanet (Current version: 1.1.2)"),
  /*#__PURE__*/_createElementVNode("div", { class: "home-content" }, [
    /*#__PURE__*/_createElementVNode("p", null, " Welcome to my website. The main purpose of this site is to showcase my portfolio as a software developer. I started building this site in spring 2023. I used node.js for server, mySQL for database and VUE for the client as well as typescript for general programming. Unit testing was done with Jest. You can read more about this and other projects from the projects page. "),
    /*#__PURE__*/_createElementVNode("p", null, "I hope you enjoy your stay."),
    /*#__PURE__*/_createElementVNode("p", null, "- Mika-Matti")
  ])
], -1))
const _hoisted_2 = { class: "nodes" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Latest posts", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_PostNode = _resolveComponent("PostNode")!
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageHeader),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post) => {
          return (_openBlock(), _createElementBlock("li", {
            key: post.post_id
          }, [
            _createVNode(_component_PostNode, { post: post }, null, 8, ["post"])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_LoadingScreen, {
      error: _ctx.error,
      display: _ctx.display
    }, null, 8, ["error", "display"])
  ], 64))
}